import _get from 'lodash/get'
import _split from 'lodash/split'
import _reduce from 'lodash/reduce'
import _trim from 'lodash/trim'
import {
  get,
  set,
  expire,
} from 'cookies-js'
import { canSetCookie } from 'services/local-preferences'
import { get as getConfig } from 'config'
import { isProduction } from 'environment'
import { isBrowser } from 'config/environment'

const config = getConfig()
const dataPrivacyCompliance = _get(config, ['features', 'anonymousUser', 'dataPrivacyCompliance'])
const oneTrustEnabled = !!_get(config, ['features', 'oneTrust'])

function getCookieDomain () {
  return !process.env.NODE_ENV || !isProduction()
    ? 'localhost'
    : '.gaia.com'
}

export function setCookie (name, value, path = '/', expires = 86400, secure = false, uid, authToken) {
  // if One Trust is enabled, then allow cookies to be set.
  // all of the places that set cookies needs to be responsible for making sure it is ok to do so
  if (oneTrustEnabled) {
    return set(name, value, {
      expires, // time in seconds
      domain: getCookieDomain(),
      path,
      secure,
    })
  }

  /* eslint-disable consistent-return */
  if (!canSetCookie(uid, authToken) && dataPrivacyCompliance && !oneTrustEnabled) {
    return
  }

  return set(name, value, {
    expires, // time in seconds
    domain: getCookieDomain(),
    path,
    secure,
  })
  /* eslint-enable consistent-return */
}

export function getCookie (name) {
  if (name) {
    return get(name)
  }
  return get()
}

export function expireCookie (name) {
  return expire(name, { domain: getCookieDomain() })
}

export function getAllCookies () {
  if (!isBrowser()) {
    return {}
  }

  return _reduce(
    _split(document?.cookie || '', ';'),
    (cookies, cookieStr) => {
      const [name, ...rest] = _split(cookieStr, '=')
      return {
        ...cookies,
        [_trim(name)]: decodeURIComponent(rest.join('=')),
      }
    },
    {},
  )
}
